'use strict'
import { AREA_CD, PREF_CD } from './code'
import { langData } from '@/lib/lang/index'

// 英語
export default {
  en: [
    {
      area_cd: '',
      name: langData.en.SelectArea.defaultOption,
      prefectures: []
    },
    {
      area_cd: AREA_CD.KANTO,
      name: langData.en.AreaName.kanto,
      prefectures: [
        {
          pref_cd: PREF_CD.TOKYO,
          name: langData.en.PrefectureName.tokyo
        },
        {
          pref_cd: PREF_CD.KANAGAWA,
          name: langData.en.PrefectureName.kanagawa
        },
        {
          pref_cd: PREF_CD.SAITAMA,
          name: langData.en.PrefectureName.saitama
        },
        {
          pref_cd: PREF_CD.CHIBA,
          name: langData.en.PrefectureName.chiba
        },
        {
          pref_cd: PREF_CD.GUNMA,
          name: langData.en.PrefectureName.gunma
        },
        {
          pref_cd: PREF_CD.IBARAKI,
          name: langData.en.PrefectureName.ibaraki
        }
      ]
    },
    {
      area_cd: AREA_CD.KANSAI,
      name: langData.en.AreaName.kansai,
      prefectures: []
    },
    {
      area_cd: AREA_CD.SHINETSU,
      name: langData.en.AreaName.shinetsu,
      prefectures: []
    },
    {
      area_cd: AREA_CD.CHUBU,
      name: langData.en.AreaName.chubu,
      prefectures: []
    },
    {
      area_cd: AREA_CD.KYUSHU,
      name: langData.en.AreaName.kyushu,
      prefectures: []
    }
  ]
}



// WEBPACK FOOTER //
// ./src/lib/prefecture_code/LangEnglish.js